import React, { useEffect } from "react";
import {
  Col,
  Button,
  FormGroup,
  Input,
  Card,
  CardBody,
  Label,
  Row
} from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';


export default function SalesInsertBody({ additem, onChangeForm, clearAll, items, values, onchangeunit, partyDetails, disable }) {

  return (
    <div>

      <Card>
        <CardBody>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label for="exampleCity">
                  Customer name
                </Label>

                <Select
                  value={values.customerId}
                  onChange={value =>
                    onChangeForm({ target: { name: "customerId", value: value } })
                  }
                  options={partyDetails}
                  placeholder="Select Customer"
                  isDisabled={disable}

                />
              </FormGroup>

            </Col>
            <Col md={3}>
              <FormGroup>
                <Label></Label>
                <Input
                  type="textarea"
                  id="customerAddress"
                  name="customerAddress"
                  readOnly
                  value={
                    values.customerId
                      ? (partyDetails.find((party) => party.id == values.customerId.id) || {}).address || ""
                      : ""
                  }
                />
              </FormGroup>

            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="exampleState">
                  Invoice Date
                </Label>
                <Input
                  bsSize="sm"
                  className="mb-3"
                  type="date"
                  name="invocieDate"
                  id="invocieDate"
                  onChange={onChangeForm}
                  value={values.invocieDate || ""}
                  readOnly={disable}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="exampleState">
                  Invoice Number
                </Label>
                <Input
                  bsSize="sm"
                  className="mb-3"
                  type="text"
                  name="invoiceNum"
                  id="invoiceNum"
                  autoComplete="off"
                  onChange={onChangeForm}
                  value={values.invoiceNum || ""}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <FormGroup>
                <Label for="exampleCity">
                  Item
                </Label>
                <Select
                  name="item"
                  id="item"
                  value={values.item}
                  onChange={value =>
                    onChangeForm({ target: { name: "item", value: value } })
                  }
                  options={items}
                  placeholder="Select Item"
                />

              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleState">
                  MRP
                </Label>
                <Input
                  id="mrp"
                  name="mrp"
                  bsSize="sm"
                  readOnly
                  onChange={onChangeForm}
                  value={values.mrp || ""}
                  autoComplete="off"
                />
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Quantity
                </Label>
                <Input
                  id="quantity"
                  name="quantity"
                  bsSize="sm"
                  onChange={onChangeForm}
                  value={values.quantity || ""}
                  autoComplete="off"
                  readOnly={values.item ? false : true}
                />
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Unit
                </Label>
                <Input
                  id="unit"
                  name="unit"
                  bsSize="sm"
                  type="select"
                  readOnly={values.item ? false : true}
                  onChange={onchangeunit}
                  value={values.unit || ""}
                >
                  <option value={values.baseUnit}>{values.baseUnit || ""}</option>
                  <option value={values.secondaryUnit}>{values.secondaryUnit || ""}</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Price/UNIT
                </Label>
                <Input
                  id="unitprice"
                  name="unitprice"
                  bsSize="sm"
                  onChange={onChangeForm}
                  value={values.unitprice || ""}
                  readOnly
                />
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Dis.
                </Label>
                <Input
                  id="discount"
                  name="discount"
                  bsSize="sm"
                  onChange={onChangeForm}
                  value={values.discount || ""}
                  readOnly
                />

              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Dis.Amt
                </Label>
                <Input
                  id="discountAmt"
                  name="discountAmt"
                  bsSize="sm"
                  readOnly
                  onChange={onChangeForm}
                  value={values.discountAmt || ""}
                />
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Tax
                </Label>
                <Input
                  id="tax"
                  name="tax"
                  bsSize="sm"
                  onChange={onChangeForm}
                  value={values.gstRate || ""}
                  readOnly
                />

              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Tax Amt
                </Label>
                <Input
                  id="taxamt"
                  name="taxamt"
                  bsSize="sm"
                  readOnly
                  onChange={onChangeForm}
                  value={values.taxamt || ""}
                />

              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label for="exampleZip">
                  Amount
                </Label>
                <Input
                  id="amount"
                  name="amount"
                  bsSize="sm"
                  onChange={onChangeForm}
                  value={(values.quantity * values.unitprice) || ""}
                  readOnly
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup row>
            <Col md="3" />
            <Col md="3">
              <Button
                name="Submit"
                id="Submit"
                className="btn-info"
                onClick={additem}
              >
                Add item
              </Button>
            </Col>
            <Col md="3">
              <Button
                onClick={clearAll}
                name="Submit"
                id="Submit"
                className="btn-warning"
              >
                Cancel
              </Button>
            </Col>
          </FormGroup>

        </CardBody>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesInsertBody.js